module.exports = __webpack_public_path__ + "static/media/242 Park - Concept Drawing 4.84e5eb82.jpg";